"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useTimeoutOnce(effect, timeout, isTiming) {
    const fired = (0, react_1.useRef)(false);
    const timer = (0, react_1.useRef)(null);
    const startTimer = (0, react_1.useCallback)(() => {
        if (!timer.current && !fired.current) {
            timer.current = window.setTimeout(() => {
                fired.current = true;
                effect();
            }, timeout);
        }
    }, [timeout, effect]);
    const cancelTimer = (0, react_1.useCallback)(() => {
        if (timer.current && !fired.current) {
            window.clearTimeout(timer.current);
            timer.current = null;
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isTiming) {
            startTimer();
        }
        else {
            cancelTimer();
        }
        return cancelTimer;
    }, [isTiming, startTimer, cancelTimer]);
}
exports.default = useTimeoutOnce;
//# sourceMappingURL=use-timeout-once.js.map